import { cn } from "../../libs/cn";
import { TextArea as TextFieldPrimitive } from "@kobalte/core/text-field";
import { splitProps } from "solid-js";


export const TextArea = (
	props,
) => {
	const [local, rest] = splitProps(props, ["class"]);

	return (
		<TextFieldPrimitive
			class={cn(
				"flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm transition-shadow placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-[1.5px] focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
				local.class,
			)}
			{...rest}
		/>
	);
};
